"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgba = void 0;
const hexToRgb_1 = require("./hexToRgb");
const hexToRgba = (hex, opacity) => {
    if (opacity > 1 || opacity < 0) {
        throw new Error('Opacity must be >= 0 and <= 1');
    }
    return [...(0, hexToRgb_1.hexToRgb)(hex), opacity];
};
exports.hexToRgba = hexToRgba;
//# sourceMappingURL=hexToRgba.js.map